import AsyncApiComponent from './containers/AsyncApi/AsyncApi';
import AsyncApiComponentWP from './containers/AsyncApi/Standalone';
export { PluginSlot, } from './types';
import { hljs } from './helpers';
export { AsyncApiComponentWP, hljs };
export default AsyncApiComponent;
//# sourceMappingURL=index.js.map